<div class="dropdown" (clickOutside)="outclick()">
    <button class="btn" (click)="toggleDropdown($event)"
            [ngClass]="{'open':isDropdownOpen,'disabledropdown' :disabledropdown}" [disabled]="disabledropdown">
        <div class="pull-left inputValFontSizeLineHeight placeholderWrapper">
            <div class="firstPlaceHolderDropdown" [style.max-width]="_placeholderWidth">
                {{_placeholder}}&nbsp;{{_placeholderback}}
            </div>
                 
        </div>
        <i class="icon-v4-Arrow_down_SPECIAL"></i>
    </button>   
    <ul class="dropdown-menu" [hidden]="!isDropdownOpen" [ngClass]="{'open-success':isDropdownOpen}">
        <div class="scroolContent">
        <li ng-show="multiple" [hidden]="_data.length < 2">
            <button class="btn-link btn-small" (click)="toggleSelectAll()">
                <input type="checkbox" [checked]="isAllItemsSelected()" /><span>ALL</span>
            </button>
        </li> 
 
            <li *ngFor="let i of _data" >
            <button class="btn-link btn-small" (click)="onItemClick($event,i);btnApply()">
                <input type="checkbox" [checked]="isSelected(i)" /><span>{{i.text}}</span>
            </button>
        </li>
</div>
        <div class="footer" [hidden]="_data.length < 2">
            <input type="button" value="Reset" name="resetBtn" (click)="uncheckAll()" 
                class="cancelBtn" />
        </div>
    </ul>

</div>
<style>
    .open-success {
        display: block !important;
    }

    .disabledropdown {
        cursor: not-allowed;
        background: #00a3e0;
        opacity: 0.4;
        border: none;
    }
    .placeholderWrapper {
        display:inline-block;
    }
</style>